import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Typography } from 'common/typography'
import { FaGithub } from 'react-icons/fa'
import { TransparentButton } from 'common/button'

const PortfolioProjectStyled = styled.li`
  p {
    margin-bottom: 1rem;
  }
  h3 {
    margin-block-start: 16px;
    margin-block-end: 8px;
  }
  .image-container {
    position: relative;
    display: block;
    &:hover .project-link {
      visibility: visible;
      opacity: 1;
    }
  }
  .project-link {
    position: absolute;
    background: rgb(0 0 0 / 50%);
    display: flex;
    align-items: center;
    justify-content: center;
    inset: 0;
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.2s ease-in;
    p {
      cursor: pointer;
      width: 200px;
      height: 200px;
      border-radius: 50%;
      background: whitesmoke;
      display: flex;
      color: var(--neutral100);
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 4px;
      font-weight: 600;
    }
  }
  .img-cover {
    object-fit: cover;
    object-position: top;
    max-width: 100%;
    width: 100%;
    aspect-ratio: 1 / 1;
    height: 100%;
  }
  .github-link svg {
    margin-inline-end: 8px;
  }
  @media (min-width: 768px) {

  }
  @media (min-width: 1366px) {
    position: relative;
    overflow: hidden;
  }
`

function PortfolioProject({
  title, description, project_url, repository_url, cover, username
}) {
  return (
    <PortfolioProjectStyled>
      <a href={project_url} target="_blank" rel="noopener noreferrer" className="image-container">
        <img className="img-cover" width={576} height={576} src={cover} alt={`Captura de ${title}`} loading="lazy" />
        <div className="project-link">
          <p>Ver proyecto</p>
        </div>
      </a>
      <Typography as="h3" font="headline5" color="var(--baseNeutral)">
        {title}
      </Typography>
      <Typography color="var(--neutral40)" font="regular">{description}</Typography>
      {repository_url ? (
        <TransparentButton
          className="github-link"
          as="a"
          href={repository_url}
          target="_blank"
          rel="noopener noreferrer"
          color="var(--turquoise)"
        >
          <FaGithub size={18} color="var(--lightBlue)" />
          <span>Ver codigo</span>
        </TransparentButton>
      ) : null}
    </PortfolioProjectStyled>
  )
}


PortfolioProject.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
  project_url: PropTypes.string.isRequired,
  repository_url: PropTypes.string.isRequired,
  cover: PropTypes.string.isRequired,
}

export default PortfolioProject
